import React, {
  Fragment,
  useState,
  MouseEvent,
  Dispatch,
  SetStateAction
} from 'react'

import { Popover, IconButton, Button, Typography } from '@mui/material'

import { useStyles } from './style'
import { funnel } from '../../images/funnel'

interface PopOverMenuProps {
  setSorter?: Dispatch<SetStateAction<number>>
}

export const PopOverMenu: React.FC<PopOverMenuProps> = () => {
  const classes = useStyles()

  const [anchorEl, setAnchorEl] = useState<Element | null>(null)

  const handleClick = (event: MouseEvent) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <Fragment>
      <IconButton
        edge='end'
        aria-label='account of current user'
        aria-haspopup='true'
        color='inherit'
        onClick={handleClick}
      >
        <img
          src={funnel}
          alt='funnel'
          style={{
            width: '16px',
            height: '16px',
            maxWidth: '16px',
            minWidth: '16px',
            marginTop: '4px',
            opacity: '0.5'
          }}
        />
      </IconButton>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >
        <div className={classes.container}>
          <Button
            color='primary'
            onClick={() => {
              handleClose()
            }}
            className={classes.button}
            disabled={true}
          >
            <Typography variant='overline' display='block' gutterBottom>
              Por orden alfábetico
            </Typography>
          </Button>
          <Button
            color='primary'
            onClick={() => {
              handleClose()
            }}
            className={classes.button}
            disabled={true}
          >
            <Typography variant='overline' display='block' gutterBottom>
              Por orden ascendente
            </Typography>
          </Button>
          <Button
            color='primary'
            onClick={() => {
              handleClose()
            }}
            className={classes.button}
            disabled={true}
          >
            <Typography variant='overline' display='block' gutterBottom>
              Por orden descendente
            </Typography>
          </Button>
        </div>
      </Popover>
    </Fragment>
  )
}
